window.addEventListener('DOMContentLoaded', (event) => {
    const initCartUpsell = async (preload = false) => {
        document.querySelector('#CartDrawer #eg-cart-upsell')?.remove();

        const element = document.querySelector('#eg-cart-upsell');
        const cartDrawerItems = document.querySelector('cart-drawer-items');

        // Add a check to ensure that we are only inserting it into the cart drawer
        if (element && cartDrawerItems && document.querySelector('#CartDrawer.drawer--open')) {
            cartDrawerItems.insertAdjacentElement('beforeend', element.cloneNode(true));
            document.querySelector('#CartDrawer #eg-cart-upsell').style.display = 'block';

            if (preload) {
                document.querySelector('#CartDrawer #eg-cart-upsell').style.opacity = '0.2';
            }

            // Add other event listeners as needed (e.g., for the variant image change, add to cart buttons)
        }
    };

    initCartUpsell();
});
